import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import MyPortfolioCard from 'uI/MyPortfolioCard/MyPortfolioCard';
import ShowDegree from 'uI/ShowDegree/ShowDegree';
import Loading from 'uI/Loading/Loading';
import LoginForm from 'components/LoginForm/LoginForm';
import FormContainer from 'uI/FormContainer/FormContainer';

import { endedCourses } from 'store/courses-actions';
import classes from './MyPortfolio.module.css';

const MyPortfolio = () => {
  const { t } = useTranslation(['login']);
  const dataUser = useSelector(state => state.userInfo);
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [openDegree, setOpenDegree] = useState(false);
  const [urlDegree, setUrlDegree] = useState('false');
  const [courseDegree, setCourseDegree] = useState('false');
  const [endDate, setEndDate] = useState('false');

  useEffect(() => {
    (async () => {
      setCourses(await endedCourses());
      setLoading(false);
    })();
  }, []);

  const showDegreeHandler = (url, course, date) => {
    setOpenDegree(true);
    setUrlDegree(url);
    setCourseDegree(course);
    setEndDate(date);
  };

  const closeDialogDegreeHandler = () => {
    setOpenDegree(false);
    setUrlDegree('');
  };

  return (
    <div className={classes.myPortfolioContainer}>
      {dataUser.data.systemDate &&
        (dataUser.data.usuario ? (
          <>
            <div className={classes.typeSectionText}>
              <p className={classes.type}>Mis Diplomas</p>
              <span className={classes.complementaryText}>
                Para consultar tus <strong>cursos en proceso</strong>{' '}
                ve a la sección
                <Button
                  component={Link}
                  className={classes.myCoursesBtn}
                  to="/campus/myCourses"
                >
                  "Mi Campus"
                </Button>
              </span>
            </div>
            {!loading ? (
              courses.length > 0 ? (
                <div className={classes.cardsContainer}>
                  {courses.map(course => (
                    <MyPortfolioCard
                      key={course.idCourse}
                      itemData={course}
                      showDegree={showDegreeHandler}
                    />
                  ))}
                </div>
              ) : (
                <p>no hay cursos terminados</p>
              )
            ) : (
              <Loading />
            )}
            {openDegree && (
              <ShowDegree
                open={openDegree}
                closeDegree={closeDialogDegreeHandler}
                urlDegree={urlDegree}
                courseDegree={courseDegree}
                endDate={endDate}
              />
            )}
          </>
        ) : (
          <FormContainer
            title={t('principal_text')}
            btnLink="register"
            login
          >
            <LoginForm prevUrl="myPortfolio" />
          </FormContainer>
        ))}
    </div>
  );
};

export default MyPortfolio;
